var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7955 23.7998H18.8717V16.0645C18.8717 14.221 18.8345 11.8569 16.3062 11.8569C13.7407 11.8569 13.3476 13.8598 13.3476 15.9317V23.7998H8.41846V7.90955H13.151V10.0771H13.22C13.8788 8.82864 15.488 7.5111 17.8888 7.5111C22.8827 7.5111 23.8008 10.7997 23.8008 15.071V23.7998H23.7955ZM2.85769 5.74198C1.27983 5.74198 0 4.43506 0 2.8572C0 1.27894 1.27943 -0.000488281 2.85769 -0.000488281C4.43595 -0.000488281 5.71538 1.27894 5.71538 2.8572C5.71538 4.43506 4.43503 5.74198 2.85769 5.74198ZM5.32755 23.7998H0.39314V7.90955H5.32755V23.7998Z",
    fill: "#D2D2D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ea89c6788f85629c8d81de6fe230ca4d.svg";
export { ForwardRef as ReactComponent };